import React from 'react';

import CookieConsent from 'react-cookie-consent';
import { FormattedMessage } from 'react-intl';

import { StyledBanner, StyledCloseIcon } from '../Banners.style';

interface Props {
  className?: string;
}

const CookieBanner: React.FC<Props> = ({ className }) => (
  <StyledBanner className={className}>
    <CookieConsent
      disableStyles
      enableDeclineButton
      flipButtons
      location='none'
      buttonText={<FormattedMessage id={'home.cookie-consent.accept'} />}
      declineButtonText={<StyledCloseIcon />}
      containerClasses='banner-container'
      contentClasses='banner-content'
      buttonWrapperClasses='banner-button-wrapper'
      buttonClasses='banner-accept-button'
      declineButtonClasses='banner-decline-button'
    >
      <FormattedMessage id={'home.cookie-consent.message'} />
    </CookieConsent>
  </StyledBanner>
);

export default CookieBanner;
